exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.swiper-slider {\n  display: inline-block;\n}", "", {"version":3,"sources":["/Users/maxiaoxu/workspace/com/deji/business/my-activation/src/swiperslider/<input css 38>"],"names":[],"mappings":";AAAA;EACE,sBAAsB;CACvB","file":"index.vue","sourcesContent":[".swiper-slider {\n  display: inline-block;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fe85c796","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/swiperslider/index.vue
// module id = esHK
// module chunks = 1